const Psychometric_campus = {
  topic: 'pyschometric',
  level: 'Intermediate',
  totalQuestions: 100,
  perQuestionScore: 1,
 
questions: [
    {
        question: "If all roses are flowers and some flowers fade quickly, which of the following statements is true?",
        choices: [
            "All roses fade quickly",
            "Some flowers are not roses",
            "Some roses fade quickly",
            "All flowers are roses"
        ],
        type: "MCQs",
        correctAnswer: "Some flowers are not roses"
    },
    {
        question: "If the first two statements are true, is the third statement true?\n1. All cats are mammals.\n2. Some mammals are not dogs.\n3. Therefore, some cats are not dogs.",
        choices: [
            "True",
            "False",
            "Uncertain",
            "None of the above"
        ],
        type: "MCQs",
        correctAnswer: "True"
    },
    {
        question: "In a certain code language, if 'GREAT' is coded as 'HFSBU', how will 'CHAMP' be coded?",
        choices: [
            "DBNQO",
            "DBMNO",
            "DBNMP",
            "DBOLO"
        ],
        type: "MCQs",
        correctAnswer: "DBNQO"
    },
    {
        question: "Five friends - Alex, Brooke, Charlie, Dana, and Evan - are sitting in a row. Alex is to the left of Brooke and to the right of Dana. Charlie is sitting at the extreme right. Where is Evan sitting?",
        choices: [
            "To the left of Brooke",
            "To the left of Alex",
            "At the extreme left",
            "To the right of Dana"
        ],
        type: "MCQs",
        correctAnswer: "At the extreme left"
    },
    {
        question: "If 'A' is taller than 'B', and 'B' is taller than 'C', which statement is logically correct?",
        choices: [
            "A is taller than C",
            "C is taller than A",
            "A is of equal height to C",
            "B is taller than A"
        ],
        type: "MCQs",
        correctAnswer: "A is taller than C"
    },
    {
        question: "All birds can fly. Some animals that can fly are not birds. Which of the following conclusions can be drawn?",
        choices: [
            "All flying things are birds",
            "Some flying creatures are animals",
            "No animal can be a bird",
            "All flying animals are birds"
        ],
        type: "MCQs",
        correctAnswer: "Some flying creatures are animals"
    },
    {
        question: "If A is taller than B and C is shorter than A, which of the following is true?",
        choices: [
            "B is shorter than C",
            "C is taller than B",
            "A is shorter than C",
            "B is taller than C"
        ],
        type: "MCQs",
        correctAnswer: "C is taller than B"
    },
    {
        question: "In a certain language, if 'FOOD' is coded as 'GPPD', how will 'MEAL' be coded?",
        choices: [
            "NFAM",
            "NEMB",
            "NEMC",
            "NEAL"
        ],
        type: "MCQs",
        correctAnswer: "NEMB"
    },
    {
        question: "Every time Lucy speaks, John sneezes. John spoke three times. How many times can we conclude Lucy spoke?",
        choices: [
            "0",
            "1",
            "3",
            "More than 3"
        ],
        type: "MCQs",
        correctAnswer: "3"
    },
    {
        question: "Two statements are given:\n1. If it rains, the ground gets wet.\n2. The ground is not wet. Which conclusion can be drawn?",
        choices: [
            "It rained",
            "It did not rain",
            "The ground might still be wet",
            "It definitely rained before"
        ],
        type: "MCQs",
        correctAnswer: "It did not rain"
    },
    {
        question: "Four friends - Alan, Bree, Claire, and Dave - are pointing in different directions. If Alan is pointing south, Bree is pointing to the east. Which direction is Claire likely pointing if Dave is her alternative?",
        choices: [
            "North",
            "South",
            "East",
            "West"
        ],
        type: "MCQs",
        correctAnswer: "West"
    },
    {
        question: "All squares are rectangles. Some rectangles are blue. Therefore, which option is logically sound?",
        choices: [
            "All squares are blue",
            "Some rectangles are not squares",
            "Some squares are blue",
            "No squares are blue"
        ],
        type: "MCQs",
        correctAnswer: "Some rectangles are not squares"
    },
    {
        question: "In a word puzzle, if 'FISH' is coded as 'GJTI', how is 'COLD' coded?",
        choices: [
            "DPLE",
            "DPLE",
            "DPLE",
            "DOME"
        ],
        type: "MCQs",
        correctAnswer: "DPLE"
    },
    {
        question: "A family has two parents and three children. If one child is a boy and another is a girl, what can we conclude?",
        choices: [
            "The third child is also a boy",
            "The third child is also a girl",
            "The third child can be of any gender",
            "All children are boys"
        ],
        type: "MCQs",
        correctAnswer: "The third child can be of any gender"
    },
    {
        question: "If all athletes are healthy and some healthy individuals are not fit, which of these statements is correct?",
        choices: [
            "All athletes are fit",
            "Some unhealthy individuals are athletes",
            "Some athletes are not fit",
            "No athlete can be unhealthy"
        ],
        type: "MCQs",
        correctAnswer: "Some athletes are not fit"
    },
    {
        question: "A train travels the distance between two cities in 2 hours. If it maintains the same speed, how long will it take to travel the distance back?",
        choices: [
            "1 hour",
            "2 hours",
            "3 hours",
            "4 hours"
        ],
        type: "MCQs",
        correctAnswer: "2 hours"
    },
    {
        question: "If a product made in Company A fails quality control but is sold in Company B's label, what can we infer about the relationship between Company A and Company B?",
        choices: [
            "Company B ensures high-quality control",
            "Company B does not perform quality checks",
            "Company B is more reliable than Company A",
            "Company A is a subsidiary of Company B"
        ],
        type: "MCQs",
        correctAnswer: "Company B does not perform quality checks"
    },
    {
        question: "Assuming everyone in a group has at least one pet, what can we conclude about someone with no pets?",
        choices: [
            "They are not part of the group",
            "They must have a pet",
            "They have been in the group previously",
            "They have a choice"
        ],
        type: "MCQs",
        correctAnswer: "They are not part of the group"
    },
    {
        question: "If all mammals are warm-blooded and some reptiles are cold-blooded, which of the following is correct?",
        choices: [
            "All reptiles are cold-blooded",
            "Some warm-blooded animals are reptiles",
            "No reptiles are mammals",
            "Some mammals are cold-blooded"
        ],
        type: "MCQs",
        correctAnswer: "No reptiles are mammals"
    },
    {
        question: "A, B, and C are siblings where A is older than both and C is younger than B. What can be inferred?",
        choices: [
            "A is the youngest",
            "B is the middle child",
            "C is the oldest",
            "A is the youngest"
        ],
        type: "MCQs",
        correctAnswer: "B is the middle child"
    },
    {
        question: "In a survey, every person who likes coffee also likes tea, but not everyone who likes tea necessarily likes coffee. If Alice likes coffee, which can we conclude?",
        choices: [
            "Alice likes tea",
            "Alice does not like tea",
            "Some coffee drinkers don’t like tea",
            "All coffee drinkers must like tea"
        ],
        type: "MCQs",
        correctAnswer: "Alice likes tea"
    },
    {
        question: "Some cats are black, and some dogs are white. If no black animals are dogs, we can conclude:",
        choices: [
            "No dog is a cat",
            "Some cats are dogs",
            "All white animals are dogs",
            "All black animals are not dogs"
        ],
        type: "MCQs",
        correctAnswer: "All black animals are not dogs"
    },
    {
        question: "If 'A' is a grandmother, which of the following can be true?",
        choices: [
            "'A' is a parent",
            "'A' is an only child",
            "'A' has no grandchildren",
            "All her children are grandchildren"
        ],
        type: "MCQs",
        correctAnswer: "'A' is a parent"
    },
    {
        question: "Four friends - Jake, Liam, Sam, and Max - are going out for dinner. If Jake does not eat meat and Liam is a vegetarian, who is likely to eat meat?",
        choices: [
            "Sam",
            "Max",
            "Both Sam and Max",
            "None of the above"
        ],
        type: "MCQs",
        correctAnswer: "Both Sam and Max"
    },
    {
        question: "In a team of five, if Ravi is not the last player and Mira is not the first player, where is Mira likely positioned?",
        choices: [
            "Last position",
            "First position",
            "Any middle position",
            "Either second or fourth position"
        ],
        type: "MCQs",
        correctAnswer: "Either second or fourth position"
    },
    {
        question: "If today is Thursday, what day will it be in two weeks?",
        choices: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday"
        ],
        type: "MCQs",
        correctAnswer: "Sunday"
    },
    {
        question: "A certain word is spelled backward as 'DROW'. What is the original word?",
        choices: [
            "DORW",
            "WORD",
            "WARD",
            "DWOR"
        ],
        type: "MCQs",
        correctAnswer: "WORD"
    },
    {
        question: "If the following statements are true, which is concluded correctly?\n1. All elephants are mammals.\n2. Some mammals are large.",
        choices: [
            "All large creatures are elephants",
            "Some elephants are large",
            "No elephants are large",
            "All mammals are elephants"
        ],
        type: "MCQs",
        correctAnswer: "Some elephants are large"
    },
    {
        question: "If A is better than B, and B can’t be better than C, what can we determine?",
        choices: [
            "C is better than A",
            "C is worse than B",
            "A is better than C",
            "B is equal to A"
        ],
        type: "MCQs",
        correctAnswer: "A is better than C"
    },
    {
        question: "In a poll, everyone who reads Fiction also reads Non-Fiction but only some who read Non-Fiction read Mystery. If David reads Fiction, what can we conclude?",
        choices: [
            "David reads Mystery",
            "David does not read Non-Fiction",
            "David reads Non-Fiction",
            "All Non-Fiction readers read Fiction"
        ],
        type: "MCQs",
        correctAnswer: "David reads Non-Fiction"
    },
    {
        question: "If every human has a heart and a certain group of beings is identified that has no hearts, what can we deduce?",
        choices: [
            "No humans are part of that group",
            "Some humans may lack a heart",
            "All beings without hearts are humans",
            "Definitely no humans have hearts"
        ],
        type: "MCQs",
        correctAnswer: "No humans are part of that group"
    },
    {
        question: "If Susan can swim faster than Tom and Tom swims faster than Lexi, who can we conclude swims slowest?",
        choices: [
            "Susan",
            "Tom",
            "Lexi",
            "Both Tom and Lexi swim equally slow"
        ],
        type: "MCQs",
        correctAnswer: "Lexi"
    },
    {
        question: "If A = B and B = C, what will be true?",
        choices: [
            "A = C",
            "B = A",
            "C = V",
            "None of the above"
        ],
        type: "MCQs",
        correctAnswer: "A = C"
    },
    {
        question: "In a meeting, Alice is speaking. If Bob speaks next, which of the following can be concluded?",
        choices: [
            "No one else will speak",
            "Alice will not speak again",
            "Bob can speak on behalf of Alice",
            "All speakers must alternate"
        ],
        type: "MCQs",
        correctAnswer: "Alice will not speak again"
    },
    {
        question: "Some doctors are not intelligent. If Dr. Smith is a doctor, can we conclude that he is not intelligent?",
        choices: [
            "Yes, definitely",
            "No, he could be intelligent",
            "Only if he is in the category",
            "Cannot be decided"
        ],
        type: "MCQs",
        correctAnswer: "No, he could be intelligent"
    },
    {
        question: "If Peter is not the oldest of the group and John is younger, who is the oldest?",
        choices: [
            "Peter",
            "John",
            "Neither, there’s someone older",
            "Cannot be determined"
        ],
        type: "MCQs",
        correctAnswer: "Neither, there’s someone older"
    },
    {
        question: "Four cars are parked in a row. If Car A is to the left of Car B and Car C is to the right of Car D, what can be identified?",
        choices: [
            "Car A may be next to Car C",
            "Car C cannot be next to Car B",
            "Car D must be on the extreme right",
            "Car B is to the left of Car C"
        ],
        type: "MCQs",
        correctAnswer: "Car B is to the left of Car C"
    },
    {
        question: "If only some of the A's are B's, can we conclude that A's are also C's if all C's are B's?",
        choices: [
            "Yes",
            "No",
            "It’s inconclusive",
            "Possibly true"
        ],
        type: "MCQs",
        correctAnswer: "No"
    },
    {
        question: "Forecast states all events happening outside are rainproof. If an event planned today is held outside, what can we conclude?",
        choices: [
            "No rain will occur",
            "The event might be interrupted",
            "People will not get wet",
            "All events must be canceled"
        ],
        type: "MCQs",
        correctAnswer: "People will not get wet"
    },
    {
        question: "If X is twice as old as Y and Y is half as old as K, which statement is accurate?",
        choices: [
            "K is older than X",
            "Y and X have the same age",
            "X is older than K",
            "All are of the same age"
        ],
        type: "MCQs",
        correctAnswer: "K is older than X"
    },
    {
        question: "Is this a logical sequence?\n1. No humans can fly.\n2. All humans have wings.",
        choices: [
            "Yes, both are logical",
            "Yes, but not both can be true",
            "No, both can’t exist together",
            "Neither is related to flying"
        ],
        type: "MCQs",
        correctAnswer: "No, both can’t exist together"
    },
    {
        question: "If Mike is not a teacher and he is a student, can we determine he is not an educator?",
        choices: [
            "Yes",
            "No",
            "It depends on his qualifications",
            "There’s no conclusion to make"
        ],
        type: "MCQs",
        correctAnswer: "Yes"
    },
    {
        question: "The cat chased the mouse, and the mouse ran safely back home. What conclusion can we draw?",
        choices: [
            "The cat never caught the mouse",
            "The mouse isn’t afraid",
            "The cat lost",
            "All of the above"
        ],
        type: "MCQs",
        correctAnswer: "All of the above"
    },
    {
        question: "If an athlete wins a gold medal, what can be affirmed about their performance?",
        choices: [
            "They outperformed everyone",
            "They are the only winner",
            "Their sport is the most preferable",
            "Performance can be calculated across events"
        ],
        type: "MCQs",
        correctAnswer: "They outperformed everyone"
    },
    {
        question: "If every animal that swims is not a bird and some birds are fish, what can we conclude?",
        choices: [
            "All fish can swim",
            "Some fish are not birds",
            "Birds cannot swim",
            "Some birds are not animals"
        ],
        type: "MCQs",
        correctAnswer: "Some fish are not birds"
    },
    {
        question: "If X is greater than Y and Y is greater than Z, and Z cannot be negative, what is identified?",
        choices: [
            "Y can be zero",
            "X must also be negative",
            "Z must be even",
            "X is positive"
        ],
        type: "MCQs",
        correctAnswer: "X is positive"
    },
    {
        question: "If no one is allowed to park in front of a fire hydrant, which option can we agree on if someone does?",
        choices: [
            "They will get a ticket",
            "They followed a rule",
            "They are permitted",
            "They did not block the path"
        ],
        type: "MCQs",
        correctAnswer: "They will get a ticket"
    },
    {
        question: "If a politician makes a promise, and it is not fulfilled, what can we conclude?",
        choices: [
            "That politician must be replaced",
            "The promise was insignificant",
            "Trust must be re-evaluated",
            "All politicians make false promises"
        ],
        type: "MCQs",
        correctAnswer: "Trust must be re-evaluated"
    },
    {
        question: "If all teachers are kind and some students are unkind, which must be correct?",
        choices: [
            "Students can be teachers",
            "Not all unkind individuals are teachers",
            "Kindness is learned",
            "Some unkind are teachers"
        ],
        type: "MCQs",
        correctAnswer: "Not all unkind individuals are teachers"
    },
    {
        question: "If every hotel has a swimming pool, which additional conclusion can we draw about a certain hotel that does not?",
        choices: [
            "It must be a residence",
            "It certainly does not exist",
            "It's not considered a hotel",
            "The design is unique"
        ],
        type: "MCQs",
        correctAnswer: "It's not considered a hotel"
    },
    {
        question: "The sun rises in the east. If it is a certain time of day, which logical conclusion can arise?",
        choices: [
            "The sun is directly overhead",
            "The sun sets in the east",
            "It must be morning",
            "There’s no way to know"
        ],
        type: "MCQs",
        correctAnswer: "It must be morning"
    },
    {
        question: "If all fruits contain seeds but some vegetables do not, what's concluded if the vegetable has seeds?",
        choices: [
            "It is a fruit",
            "It has always been a fruit",
            "It can be classified both ways",
            "It is unique"
        ],
        type: "MCQs",
        correctAnswer: "It can be classified both ways"
    },
    {
        question: "Andrew only drives on weekends; today is Saturday. What can we conclude about Andrew?",
        choices: [
            "He is driving today",
            "He is not driving today",
            "He prefers driving on weekdays",
            "He has a car"
        ],
        type: "MCQs",
        correctAnswer: "He is driving today"
    },
    {
        question: "If all guitars are string instruments, which follows if some string instruments are played with a bow?",
        choices: [
            "All guitars can be played with a bow",
            "Some guitars cannot be played with a bow",
            "No string instruments are guitars",
            "Only guitars are string instruments"
        ],
        type: "MCQs",
        correctAnswer: "Some guitars cannot be played with a bow"
    },
    {
        question: "If a person fails a test but studied hard, what can we infer about the test?",
        choices: [
            "The study material was irrelevant",
            "The test format was not appropriate",
            "They need better study habits",
            "They might have had a bad day"
        ],
        type: "MCQs",
        correctAnswer: "The study material was irrelevant"
    },
    {
        question: "If every dog barks, which conclusion is valid if Rex does not bark?",
        choices: [
            "Rex is not a dog",
            "Rex barks sometimes",
            "All dogs take a vow",
            "Rex must be a cat"
        ],
        type: "MCQs",
        correctAnswer: "Rex is not a dog"
    },
    {
        question: "Every time it snows, the roads become slippery. If the roads are slippery today, can we infer?",
        choices: [
            "It has snowed",
            "It could be icy",
            "Cars will lose control",
            "Traffic must be heavy"
        ],
        type: "MCQs",
        correctAnswer: "It could be icy"
    },
    {
        question: "If a new policy requires stronger security at an event, what can occur as a result?",
        choices: [
            "Increased safety",
            "Government penalties",
            "Fewer attendees",
            "Possible cancellations"
        ],
        type: "MCQs",
        correctAnswer: "Increased safety"
    },
    {
        question: "In a team of five members, if Sarah is not paired with Tom, who must she be with?",
        choices: [
            "No specification",
            "Only equal partners",
            "A member from another team",
            "Stay alone"
        ],
        type: "MCQs",
        correctAnswer: "No specification"
    },
    {
        question: "If things are either black or white, and an object is black, which is true?",
        choices: [
            "Object is neither",
            "Object is in color",
            "Object can’t be white",
            "Object can be grey"
        ],
        type: "MCQs",
        correctAnswer: "Object can’t be white"
    },
    {
        question: "If Mary is at her desk, and her phone is ringing, what can be inferred?",
        choices: [
            "She has a call waiting",
            "None is at her desk",
            "She ignores calls",
            "The ringing is a distraction"
        ],
        type: "MCQs",
        correctAnswer: "She has a call waiting"
    },
    {
        question: "If a book contains over 50 pages and a chapter has 10 pages, what's evaluated if there are four chapters?",
        choices: [
            "At least 40 pages",
            "Chapters are short",
            "Book exceeds 50 pages",
            "Incorrect calculations"
        ],
        type: "MCQs",
        correctAnswer: "Book exceeds 50 pages"
    },
    {
        question: "If each car in a parking lot can seat five people, how many people can fit in two cars?",
        choices: [
            "10",
            "8",
            "6",
            "Cannot be determined"
        ],
        type: "MCQs",
        correctAnswer: "10"
    },
    {
        question: "A train travels from city A to city B in under 5 hours. If it reaches city B, what can we confirm?",
        choices: [
            "The train makes scheduled times",
            "The ride was comfortable",
            "It didn't stop along the way",
            "It's below speed limits"
        ],
        type: "MCQs",
        correctAnswer: "The train makes scheduled times"
    },
    {
        question: "Every rose has petals, and if all flowers are roses, what can be identified?",
        choices: [
            "Flowers lack petals",
            "Some flowers are not roses",
            "Petals define roses",
            "Every flower is not a rose"
        ],
        type: "MCQs",
        correctAnswer: "Petals define roses"
    },
    {
        question: "If two friends decide to meet downtown on Saturday and one friend cancels, what's true about their meeting days?",
        choices: [
            "It’s still meeting",
            "One friend must go alone",
            "It’s postponed to next time",
            "There’s no arrangement"
        ],
        type: "MCQs",
        correctAnswer: "It’s still meeting"
    },
    {
        question: "If it is always raining, can we determine everyone's mood?",
        choices: [
            "Everyone is sad",
            "Some are happy",
            "Effects vary among individuals",
            "It depends on other factors"
        ],
        type: "MCQs",
        correctAnswer: "Effects vary among individuals"
    },
    {
        question: "If lions integrate into a circus, what is the outcome according to animal handlers?",
        choices: [
            "They'll have regular servings",
            "Concern for safety grows",
            "No lions are allowed",
            "The circus will thrive"
        ],
        type: "MCQs",
        correctAnswer: "Concern for safety grows"
    },
    {
        question: "If each fruit sold is healthy and some are ripe, what’s logically accurate about ripe fruits?",
        choices: [
            "They are definitely unhealthy",
            "Some ripe fruits are not tasty",
            "Ripe fruits can be unhealthy",
            "They could consist of jams"
        ],
        type: "MCQs",
        correctAnswer: "Ripe fruits can be unhealthy"
    },
    {
        question: "If a store is completely out of stock on eggs and no deliveries have arrived, what can involve inevitable?",
        choices: [
            "Eggs may return soon",
            "Store must advertise",
            "Alternative foods will increase",
            "Customers have to wait"
        ],
        type: "MCQs",
        correctAnswer: "Customers have to wait"
    },
    {
        question: "A writer publishes in multiple genres, what can be concluded regarding their popularity?",
        choices: [
            "They reach more audiences",
            "Genres must be specific",
            "Some genres are irrelevant",
            "They have become limited"
        ],
        type: "MCQs",
        correctAnswer: "They reach more audiences"
    },
    {
        question: "Everyone at the party is either in costume or in casual wear, can we agree anything in between exists?",
        choices: [
            "All are in costumes",
            "None wear casual clothing",
            "Costume design is exclusive",
            "Anyone could wear anything"
        ],
        type: "MCQs",
        correctAnswer: "None wear casual clothing"
    },
    {
        question: "If a game includes numerous players and one team loses, what outcome established?",
        choices: [
            "A draw occurred",
            "Some lost members remain",
            "Loss indicates skills aren’t efficient",
            "All competitions are avoided"
        ],
        type: "MCQs",
        correctAnswer: "Loss indicates skills aren’t efficient"
    },
    {
        question: "In a requirement for participation, if you have to be experienced, who may not adhere?",
        choices: [
            "Inexperienced individuals",
            "Experts only",
            "Either group is accepted",
            "All can join"
        ],
        type: "MCQs",
        correctAnswer: "Inexperienced individuals"
    },
    {
        question: "If sweets are served for dessert, can we conclude that they are necessarily unhealthy?",
        choices: [
            "Yes, all sweets are unhealthy",
            "Only specific options could be healthy",
            "No, it’s all relative",
            "Sweets are categorized"
        ],
        type: "MCQs",
        correctAnswer: "No, it’s all relative"
    },
    {
        question: "A pet can only be a cat or dog. If it's proven a cat, what can we determine?",
        choices: [
            "Cannot be a dog",
            "It could be both",
            "It’s an alternative breed",
            "Cats are certainly more common"
        ],
        type: "MCQs",
        correctAnswer: "Cannot be a dog"
    },
    {
        question: "If decisions require input from majorities, what is likely if input is only removed?",
        choices: [
            "Decisions vary among individuals",
            "Avoiding conflicts settles easier",
            "Majority votes become invalid",
            "All decisions are postponed"
        ],
        type: "MCQs",
        correctAnswer: "Majority votes become invalid"
    },
    {
        question: "If the sun shines during mid-day, can we define its absence during other hours?",
        choices: [
            "It’s not possible",
            "Sun must be visible always",
            "Shadows change constantly",
            "Its position varies"
        ],
        type: "MCQs",
        correctAnswer: "Its position varies"
    },
    {
        question: "If a volunteer works unpaid, how can we regard their time commitment?",
        choices: [
            "They must be less dedicated",
            "It's a waste of energy",
            "Time spent contributes to the cause",
            "Volunteers are driven by leisure"
        ],
        type: "MCQs",
        correctAnswer: "Time spent contributes to the cause"
    },
    {
        question: "If all vehicles must halt at red lights, what outcome occurs if it's continuously red?",
        choices: [
            "Traffic backs up",
            "Cars will hold up",
            "Laws are adhered to",
            "Obeying rules remains essential"
        ],
        type: "MCQs",
        correctAnswer: "Traffic backs up"
    },
    {
        question: "If every pine tree is tall, which is valid if a certain tree isn't tall?",
        choices: [
            "It isn't a pine",
            "It could be a non-pine tree",
            "May have grown short",
            "All trees are tall"
        ],
        type: "MCQs",
        correctAnswer: "It isn't a pine"
    },
    {
        question: "If someone is always on time, is it fair to suggest they prioritize engagements?",
        choices: [
            "Yes, strict discipline is demanded",
            "Each time is subjective",
            "Reliability varies",
            "Tardiness doesn't affect their role"
        ],
        type: "MCQs",
        correctAnswer: "Yes, strict discipline is demanded"
    },
    {
        question: "Can an animal identified as wild also fit domestication criteria?",
        choices: [
            "Yes, some wild animals adapt",
            "No, they are opposed forms",
            "Only under specific conditions",
            "Both identities coexist in species"
        ],
        type: "MCQs",
        correctAnswer: "Yes, some wild animals adapt"
    },
    {
        question: "Every flower needs sunlight; if a certain flower thrives in darkness, what can be said?",
        choices: [
            "It’s not a flower",
            "It must be an alternate species",
            "Natural cycles don't affect it",
            "Sunlight exposure is unnecessary"
        ],
        type: "MCQs",
        correctAnswer: "It’s not a flower"
    },
    {
        question: "If partial refunds are offered, what’s the outcome if taken off a service?",
        choices: [
            "Full satisfaction to customers",
            "Complaints must arise",
            "It’s better than before",
            "Refunds indicate poor service"
        ],
        type: "MCQs",
        correctAnswer: "Refunds indicate poor service"
    },
    {
        question: "One person states an outcome based on guesswork; what is determinate?",
        choices: [
            "The outcome is unreliable",
            "Guesses can’t be accurate",
            "Evidence exists",
            "Guessing methods develop"
        ],
        type: "MCQs",
        correctAnswer: "The outcome is unreliable"
    },
    {
        question: "If every theory presented is contentious, which can we selectively begin?",
        choices: [
            "Some theories aren't proven",
            "Theories must confirm each",
            "Acceptance is important",
            "None work as created"
        ],
        type: "MCQs",
        correctAnswer: "Some theories aren't proven"
    },
    {
        question: "If some rugs are made of wool and others from synthetic fibers, what must be extracted?",
        choices: [
            "All rugs are made the same way",
            "No rugs are natural materials",
            "All must be scrutinized individually",
            "Either choice can exist"
        ],
        type: "MCQs",
        correctAnswer: "Either choice can exist"
    },
    {
        question: "If perceived safety labels exist on goods, what can we conclude about contradictory claims?",
        choices: [
            "They may be false",
            "Valid information overrides",
            "Perceptions change over time",
            "Signs indicate warning conditions"
        ],
        type: "MCQs",
        correctAnswer: "They may be false"
    },
    {
        question: "If patrons receive bonuses while spending, does it guarantee better service provided?",
        choices: [
            "Yes, bonuses will push",
            "All customers expect more",
            "It applies negatively",
            "Bonuses can create distractions"
        ],
        type: "MCQs",
        correctAnswer: "All customers expect more"
    },
    {
        question: "Animals must have homes; if one is found outdoors frequently, what's implicated?",
        choices: [
            "It’s abandoned",
            "It’s adapting to survival",
            "Home does exist separately",
            "Domestic animals flourish"
        ],
        type: "MCQs",
        correctAnswer: "It’s adapting to survival"
    },
    {
        question: "If everyone loves ice cream, what indicates one cannot?",
        choices: [
            "It isn't acceptable",
            "They must follow rules",
            "Preferences are individual",
            "They can't stand cold"
        ],
        type: "MCQs",
        correctAnswer: "Preferences are individual"
    },
    {
        question: "If attendance at a seminar is crucial, what happens with no visible participants?",
        choices: [
            "Sign-up was inadequate",
            "Everyone shows disinterest",
            "Enlightenment isn't reached",
            "Attendance records suggest absence"
        ],
        type: "MCQs",
        correctAnswer: "Attendance records suggest absence"
    },
    {
        question: "If all residential areas have parks, what outcome does a parkless area determine?",
        choices: [
            "It disproves vegetation",
            "It's indicated as inhabited",
            "Redefines eligibility",
            "Parks remain respected"
        ],
        type: "MCQs",
        correctAnswer: "It disproves vegetation"
    },
    {
        question: "If minimalism is praised, what becomes lesser approached?",
        choices: [
            "Overwhelming tendencies",
            "Complex installations",
            "Anything extravagant",
            "Simple comforts"
        ],
        type: "MCQs",
        correctAnswer: "Anything extravagant"
    },
    {
        question: "If tastes vary across cultures, which finale implies unity?",
        choices: [
            "Taste can align for everyone",
            "Appreciation still exists",
            "It's indeterminate",
            "Preferences establish separation"
        ],
        type: "MCQs",
        correctAnswer: "Appreciation still exists"
    },
    {
        question: "If safety guidelines are installed, is it reasonable to suggest risks are acknowledged?",
        choices: [
            "Yes, before launched",
            "No, unrealistic measures",
            "Always reposted",
            "Bulletins needed"
        ],
        type: "MCQs",
        correctAnswer: "Yes, before launched"
    },
    {
        question: "Each study concludes differently; how can that occur?",
        choices: [
            "Results are absolute",
            "Context-based variables exist",
            "Either subjectivity arises",
            "Evidence delves deeper"
        ],
        type: "MCQs",
        correctAnswer: "Context-based variables exist"
    },
    {
        question: "If crew members are astronauts, suppose one isn't accounted for; what remains?",
        choices: [
            "The launch is delayed",
            "They may be missing",
            "Other types can assist",
            "Explorations change drastically"
        ],
        type: "MCQs",
        correctAnswer: "They may be missing"
    },
    {
        question: "If some landscapes are beautiful and others are just plain, can we assert beauty exists?",
        choices: [
            "Beauty is subjective",
            "Attractive design fosters appreciation",
            "Landscapes have clear-cut definitions",
            "Tastes await to change"
        ],
        type: "MCQs",
        correctAnswer: "Beauty is subjective"
    }
]
};


export default Psychometric_campus;